/* Bakhoorlaïa — panier pleine page.
   Le markup vient de la maquette de Julie ; toutes les écritures passent par
   l'API panier de Shopify, puis la section est re-rendue depuis le serveur. */
(function () {
  'use strict';

  var SECTION = '[data-panier-page]';
  // Vrai pendant nos propres écritures : évite de re-rendre deux fois sur « panier:maj ».
  var interne = false;

  function routes() {
    return window.routes || {};
  }

  function section() {
    return document.querySelector(SECTION);
  }

  /** Enveloppe <div id="shopify-section-…"> si elle existe, sinon la section elle-même. */
  function enveloppe(el) {
    return el.closest('.shopify-section') || el;
  }

  function occupe(el, valeur) {
    if (!el) return;
    el.setAttribute('aria-busy', valeur ? 'true' : 'false');
    var boutons = el.querySelectorAll('button, input[type="checkbox"]');
    for (var i = 0; i < boutons.length; i++) {
      if (valeur) boutons[i].setAttribute('disabled', '');
      else boutons[i].removeAttribute('disabled');
    }
  }

  function dire(el, message) {
    var zone = el ? el.querySelector('[data-erreur-panier]') : null;
    if (zone) zone.textContent = message || '';
  }

  function messageErreur(el) {
    var zone = el ? el.querySelector('[data-erreur-panier]') : null;
    return (zone && zone.getAttribute('data-message')) || '';
  }

  /** Re-rend la section depuis /cart?section_id=… : le serveur reste la vérité. */
  function rerendre(sectionId) {
    return fetch(routes().cart_url + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) {
        if (!r.ok) throw new Error('section');
        return r.text();
      })
      .then(function (html) {
        var neuf = new DOMParser().parseFromString(html, 'text/html');
        var neuve = neuf.querySelector(SECTION);
        var ancienne = section();
        if (!neuve || !ancienne) return;
        var cible = enveloppe(ancienne);
        var source = enveloppe(neuve);
        // La réponse contient aussi l'en-tête .panier-tete : on remplace l'ensemble.
        cible.innerHTML = source.innerHTML;
      });
  }

  function ecrire(url, corps) {
    var courante = section();
    var sectionId = courante ? courante.getAttribute('data-section-id') : null;
    if (!sectionId) return Promise.resolve(false);
    var secours = messageErreur(courante);

    occupe(courante, true);
    dire(courante, '');
    interne = true;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    })
      .then(function (r) {
        if (r.ok) return null;
        return r.json().catch(function () { return {}; });
      })
      .then(function (err) {
        if (err) {
          occupe(courante, false);
          dire(courante, err.description || err.message || secours);
          return false;
        }
        return rerendre(sectionId).then(function () {
          if (window.rafraichirTiroir) window.rafraichirTiroir();
          document.dispatchEvent(new CustomEvent('panier:maj'));
          return true;
        });
      })
      .catch(function () {
        occupe(courante, false);
        dire(courante, secours);
        return false;
      })
      .then(function (ok) {
        interne = false;
        return ok;
      });
  }

  function changerLigne(cle, qte) {
    return ecrire(routes().cart_change_url + '.js', { id: cle, quantity: qte });
  }

  function ajouterVariante(id) {
    return ecrire(routes().cart_add_url + '.js', { items: [{ id: Number(id), quantity: 1 }] });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest(SECTION)) return;

    var ligne = e.target.closest('.ligne');
    if (!ligne) return;

    var pas = e.target.closest('[data-pas]');
    if (pas) {
      e.preventDefault();
      var span = ligne.querySelector('.qte');
      var qte = Number(span ? span.textContent : 1) + Number(pas.getAttribute('data-pas'));
      if (qte < 1) qte = 1;
      changerLigne(ligne.getAttribute('data-cle'), qte);
      return;
    }

    if (e.target.classList.contains('retirer')) {
      e.preventDefault();
      changerLigne(ligne.getAttribute('data-cle'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var champ = e.target;
    if (!champ.closest || !champ.closest(SECTION)) return;
    var rapide = champ.closest('.ligne-rapide');
    if (!rapide || champ.type !== 'checkbox' || !champ.checked) return;
    ajouterVariante(champ.getAttribute('data-variante'));
  });

  // Le tiroir latéral écrit lui aussi dans le panier : on se remet d'accord.
  document.addEventListener('panier:maj', function () {
    if (interne) return;
    var courante = section();
    if (!courante) return;
    var sectionId = courante.getAttribute('data-section-id');
    if (sectionId) rerendre(sectionId);
  });
})();
